import {HrStatusEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function driverHrTagNameFilter(tag: HrStatusEnum): string {
  switch(tag) {
    case HrStatusEnum.Reported: return i18n.t(LF.ReportedInSII) as string;
    case HrStatusEnum.Active: return i18n.t(LF.ActiveInSII) as string;
    case HrStatusEnum.HadPayout: return i18n.t(LF.HadPayout) as string;
    case HrStatusEnum.ToBeReported: return i18n.t(LF.ToBeReportedInSII) as string;
    case HrStatusEnum.ToBeRemoved: return i18n.t(LF.ToBeRemovedFromSII) as string;
    case HrStatusEnum.Removed: return i18n.t(LF.RemovedFromSII) as string;
    case HrStatusEnum.MissingData: return i18n.t(LF.MissingData) as string;
    case HrStatusEnum.Other: return i18n.t(LF.DifferentProblem) as string;
    case HrStatusEnum.StudentCardRequired: return i18n.t(LF.StudentCardNeeded) as string;
    case HrStatusEnum.StudentCardUploaded: return i18n.t(LF.StudentCardUploaded) as string;
    case HrStatusEnum.Bailiff: return i18n.t(LF.Bailiff) as string;
    case HrStatusEnum.B2B: return i18n.t(LF.SettlingB2B) as string;
    case HrStatusEnum.WithoutPayout: return i18n.t(LF.WithoutPayout) as string;
    case HrStatusEnum.ActivePayoutCurrentMonth: return i18n.t(LF.ActivePayoutCurrentMonth) as string;
    case HrStatusEnum.ActivePayoutPreviousMonth: return i18n.t(LF.ActivePayoutPreviousMonth) as string;
    case HrStatusEnum.MissingTaxOffice: return i18n.t(LF.MissingTaxOffice) as string;
    case HrStatusEnum.MissingCurrentInsurance: return i18n.t(LF.MissingCurrentInsurance) as string;
    case HrStatusEnum.MissingAnnuitantCard: return i18n.t(LF.MissingAnnuitantCard) as string;
    case HrStatusEnum.MissingDisabilityCertificate: return i18n.t(LF.MissingDisabilityCertificate) as string;
    case HrStatusEnum.MissingInsuranceFromDuty: return i18n.t(LF.MissingInsuranceFromDuty) as string;
    case HrStatusEnum.MissingPensionerCard: return i18n.t(LF.MissingPensionerCard) as string;
    case HrStatusEnum.MissingPesel: return i18n.t(LF.MissingPesel) as string;
    case HrStatusEnum.Resignation: return i18n.t(LF.SiiResign) as string;
    case HrStatusEnum.UnvalidatedContractOfMandate: return i18n.t(LF.UnvalidatedContractOfMandate) as string;
    case HrStatusEnum.ValidatedContractOfMandate: return i18n.t(LF.ValidatedContractOfMandate) as string;
    case HrStatusEnum.UnvalidatedStudentStatus: return i18n.t(LF.UnvalidatedStudentStatus) as string;
    case HrStatusEnum.ValidatedStudentStatus: return i18n.t(LF.ValidatedStudentStatus) as string;
    case HrStatusEnum.TaxSituation: return i18n.t(LF.TaxSituation) as string;
    case HrStatusEnum.SiiRequest: return i18n.t(LF.SiiRequest) as string;
    case HrStatusEnum.SiiResignationRequest: return i18n.t(LF.SiiResignationRequest) as string;
    case HrStatusEnum.MissingDriverLicenseNumber: return i18n.t(LF.MissingDrivingLicenseNumber) as string;
    case HrStatusEnum.ToBeVerifiedInCepik: return i18n.t(LF.ToBeVerifiedInCepik) as string;
    case HrStatusEnum.VerifiedInCepik: return i18n.t(LF.VerifiedInCepik) as string;
    case HrStatusEnum.VerificationRejectedInCepik: return i18n.t(LF.VerificationRejectedInCepik) as string;
    case HrStatusEnum.RentOnly: return i18n.t(LF.RentOnly) as string;
    case HrStatusEnum.WorkPermitRequired: return i18n.t(LF.WorkPermitRequired) as string;
    case HrStatusEnum.ContractOfMandateOtherEmployerToVerify: return i18n.t(LF.ContractOfMandateOtherEmployerToVerify) as string;
    case HrStatusEnum.InsuredByOtherPayer: return i18n.t(LF.InsuredByOtherPayer) as string;
  }
}
